import "./list.scss";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import Card from "../card/Card";
import Duo from "../duo/Duo";
import LocalPizzaIcon from "@mui/icons-material/LocalPizza";
import { categories } from "../../data/categories";

const List = () => {
  const [category, setCategory] = useState("pizza");
  const { data, loading } = useFetch(`/products/category/${category}`);
  const [openDuo, setOpenDuo] = useState(false);

  return (
    <div className="list">
      <div className="listCategories">
        <div className="categoriesContainer">
          <ul className="categories">
            {categories.map((category) => (
              <div
                className="categoryItem"
                key={category.id}
                onClick={() => setCategory(category.name)}
              >
                <li>
                  <LocalPizzaIcon className="icon" />
                </li>
                <p className="categoryTitle">{category.name}</p>
              </div>
            ))}
          </ul>
        </div>
      </div>
      <div className="listWrapper">
        {category === "pizza" && (
          <div className="card">
            <div className="cardContainer" onClick={() => setOpenDuo(true)}>
              <img
                className="cardImage"
                src="http://res.cloudinary.com/dqknlkpku/image/upload/v1675902485/upload/yhli9sounakp2iymdmyx.png"
                alt="duo"
              />
              <div className="details">
                <p className="title">pół na pół</p>
                <p className="price">25.95zł</p>
              </div>
            </div>
          </div>
        )}
        {loading
          ? "Trwa ładowanie menu..."
          : data.filter((item) => item.isAvailable).length > 0
          ? data
              .filter((item) => item.isAvailable)
              .map((item) => <Card item={item} key={item._id} />)
          : "Produkty z tej kategorii są obecnie niedostępne."}
      </div> 
      {openDuo && <Duo closeDuo={setOpenDuo} />}
    </div>
  );
};

export default List;
